define('SageDotCom/Components/Content/IntacctResourcesCentre/IntacctResourcesFilter',["jquery",
    "knockout",
    "underscore",
    "eventManager",
    "SageDotCom/DataLayer/Events/CustomerSuccess/filterPaneEvent",
    "SageDotCom/DataLayer/Events/CustomerSuccess/filterEvent",
    "jqueryQuerystring"],
    function ($, ko, _, eventManager, filterPaneEvent, filterEvent) {

        function IntacctResourcesFilters(scope, countText, countTextPlural, contentTypeLabel, industriesLabel, productsLabel, currentMarket, data) {
            var facetTypes = {
                contentType: "ContentType",
                industry: "Industry",
                product: "Product",
            };

            //ok
            function init() {
                Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
                Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

                //Process the input data into a format for the viewModel to interact with
                var marketObjects = [];
                marketObjects.push(new MarketObj(1, "market", "en-gb", data));

                //Create and apply the viewModel
                var stickyNav = $(".sticky-nav.spotlight").get(0);
                var wrapper = $scope.find(".intacct-resources-filter-wrapper").get(0);

                var viewModel = new FilterViewModel(marketObjects, stickyNav, wrapper);

                if (wrapper) {
                    ko.applyBindings(viewModel, wrapper);
                }

                $(".intacct-resources-filter-button").addClass("prevent-tracking").removeAttr("href");

                $(".intacct-resources-filter-button").click(function (e) {
                    var opening = viewModel.toggle();
                    //new filterPaneEvent("Button Click", opening, false, this).trigger();
                });

                //Close the filter if anything other than the pane or filter button is clicked
                $(document).click(function (e) {
                    if (viewModel.isOpen()) {
                        //If clicked on the filter pane itself, don't close
                        var parents = $(e.target).parents();
                        var filterClicked = parents.hasClass("intacct-resources-filter-pane") || $(e.target).hasClass("intacct-resources-filter-pane");

                        if (!filterClicked) {
                            //if a filter button was clicked, ignore the event
                            var buttonClicked = parents.hasClass("intacct-resources-filter-button") || $(e.target).hasClass("intacct-resources-filter-button");

                            if (!buttonClicked) {
                                viewModel.hide();

                                var overlayClicked = parents.hasClass("intacct-resources-filter-overlay") || $(e.target).hasClass("intacct-resources-filter-overlay");
                                if (overlayClicked) {
                                    //new filterPaneEvent("Filter Overlay", false, false, e.target).trigger();
                                } else {
                                    //new filterPaneEvent("Body Click", false, false, e.target).trigger();
                                }
                            }
                        }
                    }
                });
            };

            function getMatchingFacet(searchCollection, nameToFind) {
                return _.findWhere(searchCollection, { name: nameToFind });
            }

            //Given the data collection, return the data that matches the given facet Id
            function filterDataObjectsByFacet(dataCollection, facetType, facetName) {
                if (facetType == facetTypes.contentType) {
                    return _.filter(dataCollection,
                        function (dataObj) {
                            return dataObj[facetTypes.contentType].Text == facetName;
                        });
                } else if (facetType == facetTypes.industry) {
                    return _.filter(dataCollection,
                        function (dataObj) {
                            return _.some(dataObj[facetType], { Text: facetName });
                        });
                }
                else {
                    return _.filter(dataCollection,
                        function (dataObj) {
                            return dataObj[facetType] == facetName;
                        });
                }
            }

            //Represents a Market and the associated stories
            function MarketObj(id, name, isocode, data) {
                var self = this;
                self.id = id;
                self.isocode = isocode;
                self.name = name;
                self.data = data
                self.countText = "(" + self.data.length + ")";

                self.selected = ko.observable(false);
                self.isDisabled = ko.observable(false);
                self.isVisible = ko.observable(false);

                self.toggle = function () {
                    if (!self.isDisabled()) {
                        var newVal = !self.selected();
                        self.selected(newVal);

                        //new filterEvent(false, false, newVal, self.name, marketsLabel).trigger();
                    }
                }

                //Return the data for this market
                self.getFacetData = function () {
                    var returnData = {
                        contentTypes: [],
                        industries: [],
                        products: []
                    };

                    //For each facet, if it already exists in the return data, increment the count, otherwise create it
                    _.map(self.data,
                        function (data) {

                            var existingContentType = getMatchingFacet(returnData.contentTypes, data[facetTypes.contentType].Text);
                            if (existingContentType) {
                                existingContentType.count++;
                            } else {
                                returnData.contentTypes.push({
                                    name: data[facetTypes.contentType].Text,
                                    count: 1
                                });
                            }

                            _.map(data[facetTypes.industry],
                                function (industry) {
                                    var existing = getMatchingFacet(returnData.industries, industry.Text);
                                    if (existing) {
                                        existing.count++;
                                    } else {
                                        returnData.industries.push({
                                            name: industry.Text,
                                            count: 1
                                        });
                                    }
                                });
                                
                            var existingProduct = getMatchingFacet(returnData.products, data[facetTypes.product]);
                            if (existingProduct) {
                                existingProduct.count++;
                            } else {
                                returnData.products.push({
                                    name: data[facetTypes.product],
                                    count: 1
                                });
                            }

                        });

                    return returnData;
                }
            }

            //Represents a collection of facets (i.e. content type/industries/products)
            function FacetCollection(name, type, rootViewModel) {
                var self = this;

                self.name = name;
                self.type = type;
                self.facetLimit = rootViewModel.facetLimit;
                self.rootViewModel = rootViewModel;

                self.facets = ko.observableArray();
                self.isOpen = ko.observable(false);

                self.hasFacets = ko.computed(function () {
                    return self.facets().length > 0;
                });

                //Toggles whether or not all the facets are shown, or only the first 6 (facet limit)
                self.toggle = function () {
                    self.isOpen(!self.isOpen());
                    self.dealWithVisibility();
                };

                //Handles showing/hiding the facets
                self.dealWithVisibility = function () {
                    //If all the facets should be shown, show them
                    if (self.isOpen()) {
                        _.map(self.facets(),
                            function (facet) {
                                facet.isVisible(true);
                            });
                    } else {
                        //Otherwise, only show the first 6 (facet limit)
                        for (var i = 0; i < self.facetCount(); i++) {
                            if (i < self.facetLimit) {
                                self.facets()[i].isVisible(true);
                            } else {
                                self.facets()[i].isVisible(false);
                            }
                        }
                    }

                };

                self.facetCount = ko.computed(function () {
                    return self.facets().length;
                });

                //Should the show more/show less element be displayed?
                self.showExpando = ko.computed(function () {
                    return self.facetCount() > self.facetLimit;
                });

                //Add facets to this collection
                self.addFacets = function (collection) {
                    _.map(collection,
                        function (facet) {
                            //If the facet already exists in this collection, increase the count by the number of stories added
                            var existing = getMatchingFacet(self.facets(), facet.name);

                            if (existing != null) {
                                existing.number(existing.number() + facet.count);
                            } else {
                                //Otherwise, create the new facet and add appropriate event subscriptions
                                var facetObj = new FilterFacet(facet.id, facet.name, self.name);
                                facetObj.number(facet.count);

                                facetObj.addSelectedSubscription(self.rootViewModel);

                                self.facets.push(facetObj);
                            }
                        });

                    //Sort the facets into alphabetical order
                    self.facets(_.sortBy(self.facets(), "name"));
                    self.dealWithVisibility();
                }

                //Subtract the stories that are no longer relevant (i.e. a market was deselected)
                self.subtractFacets = function (toSubtract, toKeep) {
                    //Remove facets that are not included in the toKeep collection 
                    var filtered = _.filter(self.facets(),
                        function (facet) {
                            var existing = filterDataObjectsByFacet(toKeep, self.type, facet.id);
                            return existing !== null && existing !== undefined && existing.length > 0;
                        });

                    //For facets that are about to be removed, unsubscribe from the selected event 
                    _.map(self.facets(),
                        function (facet) {
                            if (!_.contains(filtered, facet)) {
                                facet.removeSelectedSubscription();
                            }
                        });

                    self.facets(filtered);

                    //For each facet in this FacetCollection, subtract the count of the removed facet from the existing one
                    _.map(toSubtract,
                        function (facet) {
                            var existing = getMatchingFacet(self.facets(), facet.name);
                            if (existing != null) {
                                existing.number(existing.number() - facet.count);
                            }
                        });

                    self.dealWithVisibility();
                }

                //Programmatically select the specified facets
                self.selectFacets = function (toSelect, deselectOthers) {
                    _.map(self.facets(),
                        function (facet) {
                            if (_.contains(toSelect, facet.name)) {
                                facet.selected(true);
                            } else {
                                if (deselectOthers) {
                                    facet.selected(false);
                                }
                            }
                        });
                }

                //Reset the collection to default (i.e. nothing selected)
                self.reset = function () {
                    _.map(self.facets(),
                        function (facet) {
                            facet.enable();
                            facet.selected(false);
                        });

                    self.dealWithVisibility();
                }

                //Return the facets that are currently selected
                self.getSelectedFacets = function () {
                    var selected = [];
                    _.map(self.facets(),
                        function (facet) {
                            if (facet.selected()) {
                                selected.push(facet);
                            }
                        });

                    return selected;
                }

                self.recalculateCounts = function (dataCollection, selectedContentType, selectedIndustries, selectedProducts) {
                    var filterToApply = {};
                    filterToApply[facetTypes.contentType] = selectedContentType;
                    filterToApply[facetTypes.industry] = selectedIndustries;
                    filterToApply[facetTypes.product] = selectedProducts;

                    if (self.type == facetTypes.contentType) {
                        filterToApply[facetTypes.contentType] = [];
                    }

                    if (self.type == facetTypes.industry) {
                        filterToApply[facetTypes.industry] = [];
                    }

                    if (self.type == facetTypes.product) {
                        filterToApply[facetTypes.product] = [];
                    }

                    recalculateCountsUsingFilter(dataCollection, filterToApply);
                }

                //it enables and disables the filters based on selected options
                function recalculateCountsUsingFilter(dataCollection, filterData) {
                    _.map(self.facets(),
                        function (facet) {

                            //first of all, get the data that is relevant to this particular facet
                            var relevantData = filterDataObjectsByFacet(dataCollection, self.type, facet.name);

                            //next, need to further filter the data to make sure it adheres to the other aspects of the filter
                            if (filterData[facetTypes.contentType].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        //if the data adheres to any of the content types, then it is valid
                                        return _.some(filterData[facetTypes.contentType],
                                            { name: dataObj[facetTypes.contentType].Text });
                                    });
                            }

                            if (filterData[facetTypes.industry].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        //if the data adheres to any of the industries, it is valid
                                        var matchingIndustries = _.filter(dataObj[facetTypes.industry],
                                            function (dataObjIndustry) {
                                                return _.some(filterData[facetTypes.industry],
                                                    { name: dataObjIndustry.Text });
                                            });

                                        return matchingIndustries.length > 0;
                                    });
                            }
                            if (filterData[facetTypes.product].length > 0) {
                                relevantData = _.filter(relevantData,
                                    function (dataObj) {
                                        return _.some(filterData[facetTypes.product],
                                            { name: dataObj[facetTypes.product] });
                                    });
                            }

                            facet.updateCount(relevantData.length);
                        });
                }

                //Function to get the data that matches any of the facets that are selected in this collection
                //If no facets are selected, will return the unmodified collection
                self.filterDataUsingSelectedFacets = function (dataCollection) {
                    var selectedFacets = self.getSelectedFacets();
                    if (selectedFacets.length > 0) {
                        var selectedFacetNames = _.pluck(selectedFacets, "name");

                        if (self.type == facetTypes.contentType) {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    return _.contains(selectedFacetNames, dataObj[facetTypes.contentType].Text);
                                });
                        } else if (self.type == facetTypes.industry) {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    //Need to check each of the facet entries on the data itself
                                    return _.some(dataObj[self.type],
                                        function (dataObjFacet) {
                                            return _.contains(selectedFacetNames, dataObjFacet.Text);
                                        });
                                });
                        }
                        else {
                            dataCollection = _.filter(dataCollection,
                                function (dataObj) {
                                    return _.contains(selectedFacetNames, dataObj[self.type]);
                                });
                        }
                    }
                    return dataCollection;
                }
            }

            //Represents an individual facet
            function FilterFacet(id, name, collectionName) {
                var self = this;
                self.id = id;
                self.name = name;
                self.collectionName = collectionName;

                self.selectedSubscription = null;

                self.selected = ko.observable(false);
                self.isDisabled = ko.observable(false);
                self.isVisible = ko.observable(false);
                self.number = ko.observable(0);

                //Update the count of stories connected to this facet
                self.updateCount = function (number) {
                    self.number(number);
                    //If there are no stories, disable this facet
                    if (number == 0) {
                        self.disable();
                    } else {
                        self.enable();
                    }
                };

                //Display text for the number of stories connected to this facet
                self.countText = ko.computed(function () {
                    if (self.number() > 0) {
                        return "(" + self.number() + ")";
                    } else {
                        return null;
                    }
                });

                self.enable = function () {
                    self.isDisabled(false);
                };

                self.disable = function () {
                    self.isDisabled(true);
                    self.selected(false);
                };

                self.toggle = function () {
                    if (!self.isDisabled()) {
                        var newVal = !self.selected();
                        self.selected(newVal);

                        //new filterEvent(false, false, newVal, self.name, self.collectionName).trigger();
                    }
                };

                //Add a subscription to update the filter when this facet is selected
                self.addSelectedSubscription = function (rootViewModel) {
                    self.selectedSubscription = self.selected.subscribe(function () {
                        rootViewModel.updatefilter();
                    });
                }

                //Remove the subscription from memory
                self.removeSelectedSubscription = function () {
                    if (self.selectedSubscription != null) {
                        self.selectedSubscription.dispose();
                    }
                }
            }

            function FilterViewModel(markets, stickyNav, wrapper) {
                var self = this;
                self.countTextSelector = ".intacct-resources-listings .resources-count";

                self.isOpen = ko.observable(false);
                self.paneIsOpen = ko.observable(false);
                self.markets = markets;
                self.isResetting = false;
                self.isInitialising = false;

                self.debounceQuerystringUpdate = _.debounce(function (queryStringDict) {
                    var queryString = "?";
                    _.map(queryStringDict,
                        function (entry, key) {
                            if (entry.length > 0 && key.length > 0) {
                                if (queryString !== "?") {
                                    queryString += "&";
                                }
                                queryString += key + "=" + entry;
                            }
                        });

                    history.pushState("", "", queryString);
                }, 500);

                //The maximum number of facets that should be shown without "expanding" the collection
                self.facetLimit = 6;

                self.marketListOpen = ko.observable(false);
                self.isOpen = ko.observable(false);
                self.isFiltered = ko.observable(false);
                self.totalCount = ko.observable(0);
                self.filteredDataCount = ko.observable(0);
                self.facetCollections = ko.observableArray();

                function initViewModel() {
                    self.isInitialising = true;
                    self.isResetting = true;

                    self.facetCollections().push(new FacetCollection(contentTypeLabel, facetTypes.contentType, self));
                    self.facetCollections().push(new FacetCollection(industriesLabel, facetTypes.industry, self));
                    self.facetCollections().push(new FacetCollection(productsLabel, facetTypes.product, self));

                    var shouldOpen = $.Querystring("openFilter") || "";

                    for (var i = 0; i < self.markets.length; i++) {
                        var market = self.markets[i];

                        //Subscribe to selecting/deselecting the market
                        market.selected.subscribe(function () {
                            self.updateFacetsFromMarket(this);
                        }, market);

                        market.selected(true);

                        //Increase the count of stories with the number of stories in the market
                        self.totalCount(self.totalCount() + market.data.length);

                        //Show the first 6 markets (facetLimit)
                        if (i < self.facetLimit) {
                            market.isVisible(true);
                        }
                    }

                    //For each facet type
                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            //If the facet is selected in the querystring, select it in the model
                            var queryString = $.Querystring(facetCollection.type) || "";
                            if (queryString.length > 0) {
                                var toSelect = [];
                                var selectedFacets = queryString.split(",");
                                _.map(selectedFacets,
                                    function (facet) {
                                        toSelect.push(facet);
                                    });

                                facetCollection.selectFacets(toSelect, false);
                            }

                            facetCollection.dealWithVisibility();
                        });

                    self.isResetting = false;
                    self.updatefilter();
                    self.isInitialising = false;

                    $(self.countTextSelector).show();
                    if (shouldOpen) {
                        self.show(true);
                    } else {
                        self.pinWrapperBelowStickyNav();
                    }
                }

                self.pinWrapperBelowStickyNav = function () {
                    if (stickyNav) {
                        var newTop = stickyNav.getBoundingClientRect().bottom;
                        $(wrapper).css("top", newTop + "px");
                    }
                };

                //Toggle the filter pane
                self.toggle = function () {
                    var opening = false;
                    if (self.isOpen()) {
                        self.hide();
                    } else {
                        opening = true;
                        self.show(false);
                    }

                    return opening;
                };

                self.hide = function () {
                    if (self.paneIsOpen()) {
                        self.paneIsOpen(false);
                        window.setTimeout(function() {
                                self.isOpen(false);
                                $("body").removeClass("intacct-resources-no-scroll");
                            },
                            500);
                    }
                };

                self.show = function (isTriggeredByQueryString) {
                    if (!self.isOpen()) {
                        self.isOpen(true);
                        $("body").addClass("intacct-resources-no-scroll");
                        window.setTimeout(function() {
                                self.paneIsOpen(true);
                                window.setTimeout(function() {
                                        self.pinWrapperBelowStickyNav();
                                        if (isTriggeredByQueryString) {
                                            //new filterPaneEvent("button_click", true, true, null).trigger();
                                        }
                                    },
                                    200);
                            },
                            200);
                    }
                };

                //Update the facet collections in relation to the toggled market
                self.updateFacetsFromMarket = function (toggledMarket) {
                    //Gather the market's data
                    var thisMarketData = toggledMarket.getFacetData();

                    //Get the data from all of the markets that are selected (which may or may not include toggledMarket)
                    var selectedMarketData = [];
                    var selectedMarkets = _.filter(self.markets,
                        function (selfMarket) {
                            if (selfMarket.selected()) {
                                selectedMarketData.push(selfMarket.data);
                                return true;
                            } else {
                                return false;
                            }
                        });

                    selectedMarketData = _.flatten(selectedMarketData, true);

                    var contentTypeColl = _.findWhere(self.facetCollections(), { type: facetTypes.contentType });
                    var industryColl = _.findWhere(self.facetCollections(), { type: facetTypes.industry });
                    var productColl = _.findWhere(self.facetCollections(), { type: facetTypes.product });

                    if (toggledMarket.selected()) {
                        //Add the market's data to the facet collections
                        contentTypeColl.addFacets(thisMarketData.contentTypes);
                        industryColl.addFacets(thisMarketData.industries);
                        productColl.addFacets(thisMarketData.products);

                    } else {
                        //Subtract the market's data from the facet collections
                        contentTypeColl.subtractFacets(thisMarketData.contentTypes, selectedMarketData);
                        industryColl.subtractFacets(thisMarketData.industries, selectedMarketData);
                        productColl.subtractFacets(thisMarketData.products, selectedMarketData);
                    }

                    //Deal with whether or not the market should be disabled
                    if (selectedMarkets.length > 1) {
                        //Multiple markets are selected, so all can be picked
                        _.map(self.markets,
                            function (selfMarket) {
                                selfMarket.isDisabled(false);
                            });
                    } else {
                        //Only one selected, so disable it
                        _.map(selectedMarkets,
                            function (selfMarket) {
                                selfMarket.isDisabled(true);
                            });
                    }

                    //If the filter isn't in the midst of being reset, update the filter
                    if (!self.isResetting) {
                        self.updatefilter();
                    }
                }

                //The text for displaying the count (e.g. X of Y stories)
                self.countText = ko.computed(function () {
                    if (self.filteredDataCount() == 1) {
                        return countText.replace("##", self.totalCount()).replace("#", self.filteredDataCount());
                    }
                    return countTextPlural.replace("##", self.totalCount()).replace("#", self.filteredDataCount());
                });

                self.resetClick = function () {
                    self.reset();
                    //new filterEvent(true, false).trigger();
                }

                //Reset the filter
                self.reset = function () {
                    self.isResetting = true;

                    //Select the default market, and update the filter appropriately
                    _.map(self.markets,
                        function (market) {
                            //market.selected(market.isocode == currentMarket);
                            market.selected(true);
                            self.updateFacetsFromMarket(market);
                        });

                    //Reset the collections
                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            facetCollection.reset();
                        });

                    self.isResetting = false;
                    self.updatefilter();
                }

                eventManager.subscribe("intacct-resources-filter-reset", function () {
                    self.reset();
                });

                eventManager.subscribe("resources-filter-result-page-change", function (filterDict) {
                    self.isResetting = true;
                    _.map(self.markets,
                        function (marketObj) {
                            //if the market exists in the filter, it is selected, otherwise it is deselected
                            marketObj.selected(true);
                        });

                    _.map(self.facetCollections(),
                        function (facetCollection) {
                            var selectedFacetNames = _.pluck(filterDict[facetCollection.type], "name");
                            facetCollection.selectFacets(selectedFacetNames, true);
                        });

                    self.isResetting = false;
                    self.updatefilter();
                });

                //Should the show more/show less element be shown?
                self.showMarketExpando = ko.computed(function () {
                    return self.markets.length > self.facetLimit;
                });

                //Toggle whether or not more than 6 (facetLimit) markets should be shown
                self.marketExpandoToggle = function () {
                    var listIsOpen = !self.marketListOpen();
                    self.marketListOpen(listIsOpen);

                    for (var i = 0; i < self.markets.length; i++) {
                        var market = self.markets[i];
                        market.isVisible(i < self.facetLimit || listIsOpen);
                    }
                }

                self.updateTimeout = undefined;
                //When filter is applied
                //Determine the count for each facet - filter the data by ones that the filter applies to, and the facet in question
                self.updatefilter = function () {
                    clearTimeout(self.updateTimeout);

                    if (!self.isResetting) {
                        var isBeingFiltered = false;
                        var selectedDict = {};
                        var queryString = window.location.search.split("&");
                        
                        var queryStringDict = {};
                        _.map(queryString,
                            function (entry) {
                                var splitQuery = entry.split("=");
                                var queryValue = splitQuery[1] || "";
                                var keyName = splitQuery[0];
                                if (keyName.charAt(0) === "?") {
                                    keyName = keyName.slice(1);
                                }
                                queryStringDict[keyName] = queryValue.split(",");
                            });

                        //For each facet collection
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                selectedDict[facetCollection.type] = facetCollection.getSelectedFacets();
                                //If any facets are selected, add the category to the querystring
                                if (selectedDict[facetCollection.type].length > 0) {
                                    //Add the selected facets to the querystring
                                    var names = _.pluck(selectedDict[facetCollection.type], "name");
                                    queryStringDict[facetCollection.type] = names;
                                } else {
                                    queryStringDict[facetCollection.type] = "";
                                }
                            });
            

                        //Get all of the data from all selected markets
                        var selectedMarketData = [];
                        _.map(self.markets,
                            function (market) {
                                if (market.selected()) {
                                    selectedMarketData.push(market.data);
                                }
                            });

                        selectedMarketData = _.flatten(selectedMarketData, true);

                        //Update the counts for every facet in every collection
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                facetCollection.recalculateCounts(selectedMarketData,
                                    selectedDict[facetTypes.contentType],
                                    selectedDict[facetTypes.industry],
                                    selectedDict[facetTypes.product]);
                            });

                        //Next, filter the data to know how many are selected - this must be done second

                        var filteredData = selectedMarketData;
                        _.map(self.facetCollections(),
                            function (facetCollection) {
                                filteredData = facetCollection.filterDataUsingSelectedFacets(filteredData);
                            });

                        if (selectedDict[facetTypes.contentType].length > 0 ||
                            selectedDict[facetTypes.industry].length > 0 ||
                            selectedDict[facetTypes.product].length > 0) {
                            isBeingFiltered = true;
                        }

                        self.isFiltered(isBeingFiltered);
                        self.filteredDataCount(filteredData.length);

                        selectedDict["intacctResultsData"] = filteredData;

                        eventManager.trigger("intacct-resources-filter-changed", selectedDict);

                        //updates resource counter
                        self.updateTimeout = setTimeout(function () {
                            [].forEach.call(document.querySelectorAll(".intacct-resources-listings .resources-count"), function (el) {
                                var resCountTemplate = el.getAttribute('data-template');
                                var showingValue = self.filteredDataCount();
                                if (isBeingFiltered) {
                                    showingValue = $('[id^="intacctresourcescenterresults-"] .intacct-resources').children().length;
                                    showingValue = showingValue > 18 ? 18 : showingValue;
                                } else {
                                    showingValue = $('[id^="intacctresourcescenter-"] .intacct-resources').children().length;
                                }
    
                                resCountTemplate = resCountTemplate.replace("##", filteredData.length).replace("#", showingValue);
                                el.innerText = resCountTemplate;
                                el.setAttribute("results-show",showingValue);
                                el.setAttribute("results-total",filteredData.length);
                            });     
                        },100);


                        if (!self.isInitialising) {
                            self.debounceQuerystringUpdate(queryStringDict);
                        }
                    }
                };

                initViewModel();
            };

            init();
        };

        return function initIntacctResourcesFilter(args) {
            return args.IsExperienceEditorEditing === false ?
                new IntacctResourcesFilters(args.scope,
                    args.countText,
                    args.countTextPlural,
                    args.contentTypeLabel,
                    args.industriesLabel,
                    args.productsLabel,
                    args.currentMarket,
                    args.data) : null;
        };
    });
